import { z } from 'zod';

export const ProductFiltersSchema = z.object({
  category: z.string().trim().min(1).optional(),
  searchQuery: z.string().trim().min(1).optional(),
  priceRange: z
    .object({
      min: z.number().nonnegative().default(0),
      max: z.number().positive().default(0),
    })
    .refine((r) => (r.max === 0 && r.min === 0) || r.max >= r.min, {
      message: 'max must be greater than or equal to min',
      path: ['max'],
    })
    .optional(),
});

export type ProductFiltersDto = z.infer<typeof ProductFiltersSchema>;
